export const downloadTranslations = {
  en: {
    title: 'Download Finley',
    subtitle: 'Finley is available for iPhone and Android. Choose your platform below to get the app.',
    note: 'Then open the app and create your account to get started.',
    appStoreAlt: 'Download on the App Store',
    playStoreAlt: 'Get it on Google Play',
    backHome: 'Back to home',
    // Homepage "Get Finley" popover
    popoverTitle: 'Your money has a next move.',
    popoverDescription: 'Download Finley for iPhone or Android and create your account right in the app.',
    scanTitle: 'Scan to download Finley',
    closeModalLabel: 'Close download dialog',
    closeLabel: 'Close',
  },
  de: {
    title: 'Finley herunterladen',
    subtitle: 'Finley ist für iPhone und Android verfügbar. Wähle unten deine Plattform, um die App zu laden.',
    note: 'Öffne danach die App und erstelle dein Konto, um loszulegen.',
    appStoreAlt: 'Laden im App Store',
    playStoreAlt: 'Jetzt bei Google Play',
    backHome: 'Zurück zur Startseite',
    popoverTitle: 'Dein Geld hat einen nächsten Schritt.',
    popoverDescription: 'Lade Finley für iPhone oder Android und erstelle dein Konto direkt in der App.',
    scanTitle: 'Scannen und Finley laden',
    closeModalLabel: 'Download-Dialog schließen',
    closeLabel: 'Schließen',
  },
} as const

export type DownloadLocale = keyof typeof downloadTranslations
